import {
  DELETE_CART_API_REQUEST,
  DELETE_CART_API_SUCCESS,
  DELETE_CART_API_ERROR,
  DELETE_CART_SUCCESS,
  DELETE_CART_ITEM_API_REQUEST,
  DELETE_CART_ITEM_API_SUCCESS,
  DELETE_CART_ITEM_API_ERROR,
  DELETE_CART_ITEM_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function deleteCartApiRequest() {
  return {
    type: DELETE_CART_API_REQUEST,
    payload: true,
  };
}

function deleteCartApiSuccess(cart, params) {
  return {
    type: DELETE_CART_API_SUCCESS,
    payload: cart,
    params,
  };
}

function deleteCartApiError(err) {
  return {
    type: DELETE_CART_API_ERROR,
    payload: err,
  };
}

function deleteCartSuccess(params) {
  return {
    type: DELETE_CART_SUCCESS,
    payload: params,
    params,
  };
}

export function deleteCartAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //   return dispatch(deleteCartSuccess(params));
    // }
    dispatch(deleteCartApiRequest());
    return cartApi
      .deleteCart(state, params)
      .then(data => {
        dispatch(deleteCartApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(deleteCartApiError(error));
        throw error;
      });
  };
}

function deleteCartItemApiRequest() {
  return {
    type: DELETE_CART_ITEM_API_REQUEST,
    payload: true,
  };
}

function deleteCartItemApiSuccess(cart, params) {
  return {
    type: DELETE_CART_ITEM_API_SUCCESS,
    payload: cart,
    params,
  };
}

function deleteCartItemApiError(err) {
  return {
    type: DELETE_CART_ITEM_API_ERROR,
    payload: err,
  };
}

function deleteCartItemSuccess(params) {
  return {
    type: DELETE_CART_ITEM_SUCCESS,
    payload: params,
    params,
  };
}

export function deleteCartItemAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //   return dispatch(deleteCartItemSuccess(params));
    // }
    dispatch(deleteCartItemApiRequest());
    return cartApi
      .deleteCartItem(state, params)
      .then(data => {
        dispatch(deleteCartItemApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(deleteCartItemApiError(error));
        throw error;
      });
  };
}

export default {
  deleteCartAction,
  deleteCartItemAction,
};
